import { render, staticRenderFns } from "./EditPartnerPermissionsModal.vue?vue&type=template&id=5ceb0ae4&lang=pug&"
import script from "./EditPartnerPermissionsModal.vue?vue&type=script&lang=js&"
export * from "./EditPartnerPermissionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports